import React, { Component } from "react"
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Row } from "antd"

const RemotePagination = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  columns,
  defaultSorted,
  matchKey,
  rowEvents = null
}) => (
  <Row>
    <BootstrapTable
      remote
      bootstrap4
      keyField={matchKey}
      data={data}
      columns={columns}
      defaultSorted={defaultSorted}
      pagination={paginationFactory({ page, sizePerPage, totalSize, hideSizePerPage: true })}
      onTableChange={onTableChange}
      rowEvents={rowEvents}
    />
  </Row>
);

export class TableContainer extends Component {

  _mapPageData = (data, pageIds, matchKey) => {
    const pageData = data.filter(element => {
      return pageIds.includes(element[matchKey]);
    });
    return pageData;
  };

  render() {
    const { current_page, total_items } = this.props.pagination;
    const { pagination, data, matchKey, limit, defaultSorted, rowEvents } = this.props;
    let page_data = [];
    if (current_page) {
      page_data = this._mapPageData(data, pagination[current_page], matchKey);
    }

    // console.log("TableContainer props", this.props);
    // console.log("TableContainer data", page_data);

    return (
      <RemotePagination
        data={page_data}
        page={current_page}
        columns={this.props.columns}
        matchKey={this.props.matchKey}
        defaultSorted={defaultSorted}
        sizePerPage={limit}
        totalSize={total_items}
        onTableChange={this.props.onTableChange}
        rowEvents={rowEvents}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/generic/paginatedTable.js